import { ActionType, createStandardAction } from 'typesafe-actions';

export interface LoginSuccessPayload {
  username?: string;
  token: string;
}

export const authActions = {
  login: createStandardAction('@@auth/Login')<{
    username: string;
    password: string;
  }>(),
  tokenLogin: createStandardAction('@@auth/TokenLogin')<string>(),
  loginSuccess: createStandardAction('@@auth/Login/Success')<
    LoginSuccessPayload
  >(),
  loginError: createStandardAction('@@auth/Login/Error')<unknown>(),
  logout: createStandardAction('@@auth/Logout')(),
  logoutSuccess: createStandardAction('@@auth/Logout/Success')(),
  mfaLogin: createStandardAction('@@auth/MfaLogin')<{
    username: string;
    mfaVerificationCode: string;
  }>(),
  mfaLoginSuccess: createStandardAction('@@auth/MfaLogin/Success')<
    LoginSuccessPayload
  >(),
  mfaLoginError: createStandardAction('@@auth/MfaLogin/Error')<unknown>(),
  logoutError: createStandardAction('@@auth/Logout/Error')<unknown>(),
};

export type AuthActionsType = ActionType<typeof authActions>;
